/**
 * aswbe search eapi（ShoppingShopping）
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HistoryPostRequestHistoryBoundsInner } from './historyPostRequestHistoryBoundsInner';
import { Type8 } from './type8';
import { HistoryPostRequestHistoryRoundtrip } from './historyPostRequestHistoryRoundtrip';
import { NumberOfTravelers } from './numberOfTravelers';

/**
 * 検索条件
 */
export interface Items {
  /**
   * データ登録時の日時（yyyy-MM-ddTHH:mm:ss）   ※GMT   ※履歴登録API/お気に入り登録APIのリクエストとして使用された場合、この項目は設定しない
   */
  creationDateTime?: string;
  /**
   * 旅程タイプ   roundtrip：往復旅程   onewayOrMulticity：片道または複雑旅程
   */
  tripType: Items.TripTypeEnum;
  roundtrip?: HistoryPostRequestHistoryRoundtrip;
  /**
   * 片道または複雑旅程旅程バウンドリスト。   検索条件の区間数分のサイズとなる。   ※tripTypeがonewayOrMulticityの場合に設定する
   */
  bounds?: Array<HistoryPostRequestHistoryBoundsInner>;
  fare?: Type8;
  travelers?: NumberOfTravelers;
  /**
   * 別予約同行者有無
   */
  hasAccompaniedInAnotherReservation?: boolean;
  /**
   * プロモーションコード
   */
  promotionCode?: string;
}
export namespace Items {
  export type TripTypeEnum = 'roundtrip' | 'onewayOrMulticity';
  export const TripTypeEnum = {
    Roundtrip: 'roundtrip' as TripTypeEnum,
    OnewayOrMulticity: 'onewayOrMulticity' as TripTypeEnum,
  };
}
